import { Assert } from "./PADebug"
import { ArticleGW } from "./ArticleGW"
import { BuildPartGW } from "./BuildPartGW"

///////////////   SelectionSetGW  ////////////////
export interface SelectionSetItem {
    itemId: string,
    amount: number,
    pricebookId: number
}

export class SelectionSetGW {

    constructor() {
        this.m_meta = "(unknown meta)"
        this.m_name = "(unknown name)"
    }

    // Access : Items
    public SetItems(items: Array<SelectionSetItem>) {
        this.m_items = items
    }

    // Access : ID
    public SetId(id: string) {
        this.m_id = id
    }

    // Access : Name
    public SetName(name: string) {
        this.m_name = name
    }

    // Access : Meta
    public SetMeta(meta: string) {
        this.m_meta = meta
    }

    // Access : Date
    public SetTimeData(created: string, modified: string) {
        this.m_timeCreated = created
        this.m_timeModified = modified
    }

    // Converts a numeric string into a number. The string must not have any comma or decimals in it 
    public valueOfString(numericString: string) {
        var value = 0
        var potence = 1

        for (var pot = numericString.length - 1; pot >= 0; pot-- , potence *= 10) {
            value += this.valueOfLetter(numericString[pot]) * potence
        }

        return value
    }

    // Converts a numeric letter into a number from 0 to 9
    public valueOfLetter(numericLetter: string) {
        if (numericLetter == "0") {
            return 0
        }

        if (numericLetter == "1") {
            return 1
        }

        if (numericLetter == "2") {
            return 2
        }

        if (numericLetter == "3") {
            return 3
        }

        if (numericLetter == "4") {
            return 4
        }

        if (numericLetter == "5") {
            return 5
        }

        if (numericLetter == "6") {
            return 6
        }

        if (numericLetter == "7") {
            return 7
        }

        if (numericLetter == "8") {
            return 8
        }

        if (numericLetter == "9") {
            return 9
        }

        return 0
    }

    // Returns a displayable string where the time of the last save will be shown
    public GetSavedTime(localHour:number) {
        // Using UTC - for example: "2018-09-25T13:14:29.8966667"
        var sourceTime = this.m_timeCreated
        
        if (sourceTime) {
            // alert("set.GetSavedTime sourceTime:" + sourceTime + " hourDiff:" + localHour)
            var timeHereDate = this.TimeFromString(sourceTime, localHour)

            // alert("set.GetSavedTime : "+timeHereDate.toString())
            var timeHere = timeHereDate.toJSON()

            var response = ""

            for (var i = 8; i < 10; i++) {
                response += timeHere.charAt(i)
            }

            response += "-"

            for (var i = 5; i < 7; i++) {
                response += timeHere.charAt(i)
            }

            response += "-"

            for (var i = 0; i < 4; i++) {
                response += timeHere.charAt(i)
            }

            response += " - "

            for (var i = 11; i < 16; i++) {
                response += timeHere.charAt(i)
            }

            return response
        }
        else {
            return "2???-??-?? - ??:??"
        }
    }

    // Creates a displayable string from a given Date json (from the server) in order to tell when a selecton was last saved.
    public TimeFromString(timeStr: string, hourDifference: number) {
        
        var yearStr = ""
        const compensationForConversion = 0 // For some reason there was need of this compensational value to get the time correct, but
                                            // presently it is not needed, likely because of a change within the back end (?)

        for (var i = 0; i < 4; i++) {
            yearStr += timeStr.charAt(i)
        }

        var monthStr = timeStr.charAt(5) + timeStr.charAt(6)

        var dayStr = timeStr.charAt(8) + timeStr.charAt(9)

        var hourStr = timeStr.charAt(11) + timeStr.charAt(12)

        var minuteStr = timeStr.charAt(14) + timeStr.charAt(15)

        var secondStr = timeStr.charAt(17) + timeStr.charAt(17)
        
        var timeSaved = new Date(this.valueOfString(yearStr), this.valueOfString(monthStr)-1, this.valueOfString(dayStr), this.valueOfString(hourStr), this.valueOfString(minuteStr), this.valueOfString(secondStr))
        var timeAbsolute: number = timeSaved.valueOf() + ((hourDifference + compensationForConversion) * 3600000)
        var resutlTime = new Date(timeAbsolute) 
        
        return resutlTime
    }
    
    // Access : selection id
    public GetId() {
        return this.m_id
    }

    // Access : selection name
    public GetName() {
        return this.m_name
    }

    // Access : selection meta
    public GetMeta() {
        return this.m_meta
    }

    // 
    public GetSet() {
        var obj: { id: string, name: string, meta: string, items: Array<SelectionSetItem> } = {
            id: this.GetId(), name: this.GetName(), meta: this.GetMeta(), items: this.m_items
        }

        return obj
    }

    // Builds this as a selection set from an array of articles, where each occurance of an amount is represented as a SelectionSetItem in m_items
    public InitFromArticles(arts: Array<ArticleGW>) {
        this.m_items = new Array<SelectionSetItem>()
        
        var item: SelectionSetItem
        for (var i = 0; i < arts.length; i++) {
            var extData = arts[i].GetIfHasExtData()

            if (extData != null) {
                var orders = extData.GetArticleOrders(arts[i])

                for (var j = 0; orders && j < orders.length; j++) {
                    Assert(orders[j].GetOrderingId() != null, "SelectionSetGW.InitFromArticles - GetOrderingId() gave null!")
                    item = {
                        itemId: orders[j].GetOrderingId(),
                        amount: orders[j].GetAmount(),
                        pricebookId: orders[j].GetPriceBook()
                    }

                    this.m_items.push(item)
                }
            }
            else {
                item = {
                    itemId: arts[i].GetIdentifier(),
                    amount: 0,
                    pricebookId: arts[i].GetPriceBook()
                }

                this.m_items.push(item)
            }
        }
    }

    // Adds contents to this set from an additional array of articles
    public AddFromArticles(arts: Array<ArticleGW>, multiplier: number) {
        var item: SelectionSetItem
        var addedToAmount: boolean
        
        for (var i = 0; i < arts.length; i++) {
            if (arts[i].GetIfHasExtData() != null) {
                var extData = arts[i].GetIfHasExtData()
                var orders = extData && extData.GetArticleOrders(arts[i])

                for (var j = 0; orders && j < orders.length; j++) {
                    Assert(orders[j].GetOrderingId() != null, "SelectionSetGW.InitFromArticles - GetOrderingId() gave null!")
                    item = {
                        itemId: orders[j].GetOrderingId(),
                        amount: (orders[j].GetAmount() * multiplier),
                        pricebookId: orders[j].GetPriceBook()
                    }
                    
                    addedToAmount = false

                    for (var k = 0; k < this.m_items.length; k++) {
                        if (this.m_items[k].itemId == item.itemId) {
                            this.m_items[k].amount += item.amount
                            addedToAmount = true
                            break
                        }
                    }

                    if (addedToAmount == false) {
                        this.m_items.push(item)
                    }
                }
            }
            else {
                item = {
                    itemId: arts[i].GetIdentifier(), //GetNobb(),   // orders[j].GetOrderingId(),
                    amount: (arts[i].GetAmount() * multiplier),
                    pricebookId: arts[i].GetPriceBook()
                }

                addedToAmount = false

                for (var k = 0; k < this.m_items.length; k++) {
                    if (this.m_items[k].itemId == item.itemId) {
                        this.m_items[k].amount += item.amount
                        addedToAmount = true
                        break
                    }
                }

                if (addedToAmount == false) {
                    this.m_items.push(item)
                }
            }
        }
    }

    // Adds contents from a buildpart and its underlying buildparts recursively and multipliedly by amount values throughout the hierarchy
    public AddFromBuildPartsRecursion(part: BuildPartGW, multiplier: number) {
        this.AddFromArticles(part.GetArticles(), multiplier)
        const subs = part.GetIncludedBuildParts()

        for (var i = 0; i < subs.length; i++) {
            this.AddFromBuildPartsRecursion(subs[i].ref, multiplier * subs[i].amount)
        }
    }

    // Rids the m_items array from items which has the amount: 0
    ClearZeroAmounts() {
        var newItems = new Array < SelectionSetItem>()
        for (var i = 0; i < this.m_items.length; i++) {
            if (this.m_items[i].amount > 0) {
                newItems.push(this.m_items[i])
            }
        }

        this.m_items = newItems
    }

    private m_id: string
    private m_name: string
    private m_meta: string
    private m_items: Array<SelectionSetItem>
    private m_timeCreated: string | undefined
    private m_timeModified: string | undefined
}



// WEBPACK FOOTER //
// ./client/view/SelectionSetGW.tsx